import React from 'react'
import { reduxForm, Field, reset } from 'redux-form'
import emailValidator from 'email-validator'
import { useHistory } from 'react-router-dom'

import WrappedInput from 'components/Shared/Forms/WrappedInput'
import Modal from 'components/Shared/Modal'

import '../Settings.css'

const validate = ({ email }) => {
  const errors = {}

  if (!email || !emailValidator.validate(email)) {
    errors.email = 'Please enter a valid email address'
  }

  return errors
}

const InviteForm = ({ handleSubmit, valid, onClose }) => {
  const history = useHistory()

  const handleCancel = () => {
    if (onclose) {
      onClose()
    } else {
      history.goBack()
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Modal.Header>
        <h1>
          Invite New Team Member
          <span>
            This person will be both invited to your team and this app.
          </span>
        </h1>
      </Modal.Header>
      <Modal.Content>
        <Field
          inline
          small
          autoComplete="off"
          component={WrappedInput}
          name="email"
          label="Email Address"
          placeholder="elon.musk@spacex.com"
        />
      </Modal.Content>
      <Modal.Actions>
        <Modal.Button type="button" onClick={handleCancel} text>
          Cancel
        </Modal.Button>
        <Modal.Button type="submit" purple disabled={!valid}>
          Invite
        </Modal.Button>
      </Modal.Actions>
    </form>
  )
}

const afterSubmit = (result, dispatch) => {
  dispatch(reset('inviteFormModal'))
}

export default reduxForm({
  validate,
  form: 'inviteFormModal',
  onSubmitSuccess: afterSubmit,
})(InviteForm)
